import { useAuth } from "@clerk/clerk-react";
import { useCallback } from "react";

/** Calls SurgeDial Worker with Clerk session JWT. */
export function useApiFetch() {
  const { getToken, isLoaded, isSignedIn } = useAuth();

  return useCallback(
    async (path: string, init?: RequestInit): Promise<Response> => {
      const base = import.meta.env.VITE_SURGEDIAL_API_BASE ?? "";
      if (!base) {
        throw new Error("Set VITE_SURGEDIAL_API_BASE");
      }
      if (!isLoaded || !isSignedIn) {
        throw new Error("Sign in required");
      }
      const token = await getToken();
      if (!token) {
        throw new Error("No session token");
      }
      const url = `${base.replace(/\/$/, "")}${path.startsWith("/") ? path : `/${path}`}`;
      return fetch(url, {
        ...init,
        headers: {
          ...init?.headers,
          Authorization: `Bearer ${token}`,
        },
      });
    },
    [getToken, isLoaded, isSignedIn],
  );
}
